import styled from "styled-components";

export const OrderDropCss = styled.div`
  i {
    font-size: 1.5rem;
  }
  :hover {
    background-color: beige;
  }

  @media (max-width: 760px) {
    i {
      font-size: 1rem;
    }
  }
`;
